import { QueryClient } from 'react-query';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';

const useQueryCache = true;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      retry: false,
      suspense: true,
      useErrorBoundary: true,
      refetchOnWindowFocus: false,
      cacheTime: useQueryCache
        ? 1000 * 60 * 60 * 24 /* 24 hours */
        : 1000 * 60 * 5 /* 5 minutes */,
    },
  },
});

export async function setupQueryCache() {
  if (!useQueryCache) return;

  const localStoragePersistor = createWebStoragePersistor({
    storage: window.localStorage,
  });

  await persistQueryClient({
    queryClient,
    persistor: localStoragePersistor,
    buster: '2',
  });
}

export default queryClient;
